import React from "react";
import { GiChefToque, GiBlackBook } from "react-icons/gi";
import { CgLaptop } from "react-icons/cg";


import { Animate } from "react-simple-animate";
import "./styles.scss";
import Me from "../../images/me.png"


const jobSummary =
  "I am a junior AI engineer with keen interest in computer vision and experience in serveral AI projects related \
  to Computer Vision such as image classification, object detection, segmentation and OCR (optical charater recognition).\
  Actively participating in AI volunteering projects and contributing AI knowledege to the society. \
  Currently focusing on software system development by building AI software products for businesses to benefit from the power of AI. I am passionate in learning new technologies, working with team, knowledge sharing and volunteering.";

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about__content">
      
        <div className="about__content__servicesWrapper">
          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(-600px)",
            }}
            end={{
              transform: "translatex(0px)",
            }}
          >
          <img src={Me} className="about__content__image"/>
          </Animate>
        </div>
      
        <div className="about__content__personalWrapper">
          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(500px)",
            }}
            end={{
              transform: "translatex(0px)",
            }}
          >
            <h1>Know Who I'M </h1>
            <p>{jobSummary}</p>
            <p> Apart from coding, some other activities that I love to do! </p>
            <ul>
              <li>
                <span className="value">< GiChefToque/> Cooking </span>
              </li>
              <li>
                <span className="value">< CgLaptop /> Watching Anime </span><br />
              </li>
              <li>
                <span className="value">< GiBlackBook/> Learning Foreign Languages </span><br />
              </li>
            </ul>
            <p> I can speak, 3 languages! </p>
            <ul>
              <li>
                <span className="value"> Burmese </span>
              </li>
              <li>
                <span className="value"> English </span><br />
              </li>
              <li>
                <span className="value"> Japanese </span><br />
              </li>
            </ul>
            
          </Animate>
        </div>
        
      </div>
    </section>
  );
};
export default About;
